export default build =>
    build.query({
        tagTypes: ['allCashDepositRecordByAgent'],
        keepUnusedDataFor: 1,
        query(payload) {
            console.log("payload in get cash deposit",payload)            
            return {
                url: `/exam/getDepositRecord?agentId=${payload.agentId}`,
                method: 'GET',
               // body: payload,
            };
           
        },
       providesTags: ['allCashDepositRecordByAgent']
    })
